import React from 'react';

import { Alert } from '@infoods/lifebase-ui';

import { getFormattedDate } from '../../../../../shared/utils/dateUtils';
import { localDataFormat } from '../../../../../shared/constants/apiDateFormat';

type SubscriptionCancelAlertProps = {
  setupNewSubscriptionDate: string | null;
};

const SubscriptionCancelAlert = ({
  setupNewSubscriptionDate,
}: SubscriptionCancelAlertProps) => {
  if (!setupNewSubscriptionDate) {
    return null;
  }

  const formattedSetupSubscriptionDate = getFormattedDate(
    setupNewSubscriptionDate,
    localDataFormat,
  );

  return (
    <Alert severity="info" size="small">
      Subscription canceled. Customer can set up a new one on&nbsp;
      {formattedSetupSubscriptionDate}
    </Alert>
  );
};

export { SubscriptionCancelAlert };
